"use client";

import { Carousel } from "./ui/carousel";
import img1 from "../assets/gallery/img1.jpeg";
import img2 from "../assets/gallery/img2.jpeg";
import img3 from "../assets/gallery/img3.jpeg";
import img4 from "../assets/gallery/img4.jpeg";
import img5 from "../assets/gallery/img5.jpeg";
import img6 from "../assets/gallery/img6.jpeg";
import img7 from "../assets/gallery/img7.jpeg";
import img8 from "../assets/gallery/img8.jpeg";
import img9 from "../assets/gallery/img9.jpeg";
import img10 from "../assets/gallery/img10.jpeg";
import img11 from "../assets/gallery/img11.jpeg";
import img12 from "../assets/gallery/img12.jpeg";
export function CarouselComponent() {
    const slideData = [
      {
        title: "Neon Nights",
        src: img7,
        description:
          "From left to right Nikon India Managing Director Tanaka San, Singapore Service manager Itto San, Nikon India service Manager Banna San.",
      },
      {
        title: "Desert Whispers",
        src: img8,
      },
      {
        title: "Nikon Singapore",
        src: img9,
        description:
          "Nikon Singapore  ,MD Sathoshiyagi San, and service manager Hajime Nijima San  visited our service centre",
      },
      {
        title: "Nikon Singapore",
        src: img10,
        description:
          "Nikon Singapore  pte , MD   Sathoshi yagi San visited our service centre",
      },
      {
        title: "Nikon Singapore",
        src: img11,
        description:
          "Canon India Private Limited  Managing Director Kenshaki Konishi San inaugurated our Canon Service centre",
      },
      {
        title: "Nikon Singapore",
        src: img12,
      },
      {
        title: "Mystic Mountains",
        src: img1,
      },
      {
        title: "Urban Dreams",
        src: img2,
      },
      {
        title: "Neon Nights",
        src: img3,
      },
      {
        title: "Desert Whispers",
        src: img4,
      },
      {
        title: "Mystic Mountains",
        src: img5,
      },
      {
        title: "Urban Dreams",
        src: img6,
      },
    ];
  return (
    <div className="relative overflow-hidden w-full h-full py-20">
      <h2 className="text-4xl font-bold text-center mb-10">Gallery</h2>
      <Carousel slides={slideData} />
    </div>
  );
}
